export const GET_ROLE_LIST_REQUEST = '@AppProvider/GET_ROLE_LIST_REQUEST';
export const GET_ROLE_LIST_SUCCESS = '@AppProvider/GET_ROLE_LIST_SUCCESS';

export const GET_PRODUCT_LIST_REQUEST = '@AppProvider/GET_PRODUCT_LIST_REQUEST';
export const GET_PRODUCT_LIST_SUCCESS = '@AppProvider/GET_PRODUCT_LIST_SUCCESS';

export const SET_ENABLE_SELECT_ROLE = '@AppProvider/SET_ENABLE_SELECT_ROLE';